import React, {useState} from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";
import {useProfile} from "../../UserProfileProvider";
import {isContactEmailVerified} from "../../util/ContactUtil";
import {VerifyContactMethodOverlay} from "./VerifyContactMethodOverlay";
import {space} from "../../compiled";
import ContactMethodType = space.kenko.proto.ContactMethodType;

export const EditableVerifiedEmailField = <EnclosingType extends object>(props: EditableProps<EnclosingType, string>) => {

  const {editing, value, setValue} = useEditable(props);

  const {profile} = useProfile();
  
  // If they clicked the verify button
  const [isVerifying, setIsVerifying] = useState(false);

  const isVerified = isContactEmailVerified(profile);

  if (editing) {
    return <Editable {...props}>
      <input className={'EditableEditing'}
             type={'email'}
             value={value ?? ''}
             onChange={e => {
               setValue(e.target.value);
             }}/>
    </Editable>

  } else {

    return <Editable {...props}>
      <div className={'EditableNotEditing'}>
        {value} {value && (isVerified ? '[verified]' : <>[not verified] [<a
          style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={() => setIsVerifying(true)}>verify
        now</a>]</>)}
      </div>

      {isVerifying && <VerifyContactMethodOverlay
          type={ContactMethodType.EMAIL}
          value={value}
          onDone={() => setIsVerifying(false)}/>}

    </Editable>
  }
}
